import React from 'react'
import { useNavigate  } from "react-router-dom";


function Header(props) {

  const navigate = useNavigate();
  
          


  function clicMoreInfo(props) { 
    var cv = document.getElementById('canvasDiv');
    var more = document.getElementById('MoreInfo');

    
    cv.hidden = true;
    more.hidden = false;
 }


  return (
    <>
     
      <div className="z-50 border-0  text-black absolute top-0 left-0 w-full flex align-middle justify-center text-2xl" onTouchStart={(e) => { e.preventDefault(); navigate("/"); }} onMouseEnter={() => { }} onMouseLeave={() => { }} >
        {props.userInfo?.id }  HYPERURANIUM
      </div>
    </>
    )
}

export default Header

